import api from '../httpClient';
import type { DailyPulseTopic } from './dailyPulseClient';

export type AdminDailyPulseResponseType = 'rating' | 'boolean' | 'number' | 'duration' | 'time';

export interface AdminDailyPulseQuestion {
  id: string;
  key: string;
  prompt: string;
  response_type: AdminDailyPulseResponseType;
  low_label: string;
  high_label: string;
  section: string;
  topic: DailyPulseTopic;
  unit: string;
  min_value: number | null;
  max_value: number | null;
  step: number;
  display_order: number;
  version: number;
  default_enabled: boolean;
  is_active: boolean;
  is_legacy: boolean;
  has_answers: boolean;
}

export type AdminDailyPulseQuestionWrite = Omit<AdminDailyPulseQuestion,
  'id' | 'version' | 'is_legacy' | 'has_answers'>;

const path = '/api/admin/daily-pulse-questions/';

export const adminDailyPulse = {
  list: async (): Promise<AdminDailyPulseQuestion[]> => {
    const response = await api.get<{ results: AdminDailyPulseQuestion[] }>(path, {
      params: { page_size: 10000 },
    });
    return response.data.results;
  },
  create: async (payload: AdminDailyPulseQuestionWrite) => (
    await api.post<AdminDailyPulseQuestion>(path, payload)
  ).data,
  update: async (id: string, payload: Partial<AdminDailyPulseQuestionWrite> & { version: number }) => (
    await api.patch<AdminDailyPulseQuestion>(`${path}${encodeURIComponent(id)}/`, payload)
  ).data,
};
